<template>
  <AppModal
    class="cart-modal"
    size="lg"
    @close="$emit('close')"
  >
    <div class="min-h-130 flex flex-col">
      <div class="bg-secondary-subtle w-full py-4">
        <span class="text-2xl text-black font-semibold">
          Added to your cart
        </span>
      </div>

      <div class="overflow-y-auto container-padding py-4 min-h-100 flex flex-col flex-1">
        <div class="flex flex-col flex-1">
          <div class="pr-1 min-h-18 flex-1 max-h-78 overflow-y-auto">
            <div
              v-for="(item, index) in cartStore.cart?.items"
              :key="item.id"
              class="border-b border-gray-light border-solid py-4"
              :class="index === cartStore.cart?.items?.length - 1 ? '!border-none' : ''"
            >
              <div class="flex flex-col">
                <div class="flex justify-between items-center">
                  <span class="text-black font-semibold text-sm">
                    {{ item.type === PhotoType.Pack ? 'Photo Pack' : item.size === DigitalSize.Standard ? 'Standard' : 'Premium' }}
                    {{ item.quantity > 1 ? 'x' + item.quantity : '' }}
                  </span>

                  <span class="text-sm text-black">R{{ item?.price.toFixed(2) }}</span>
                </div>

                <span class="w-fit text-sm">{{ item.delivery === 'Digital' ? 'Digital Download' : 'Print' }}</span>
              </div>
            </div>

            <div
              v-if="cartStore.isLoading"
              role="status"
              class="animate-pulse flex flex-col justify-center gap-2.5 border-t border-gray-light border-solid min-h-[72px] max-h-[72px] py-4 w-full"
            >
              <div class="flex items-center justify-between w-full">
                <div class="h-2.5 rounded-full bg-gray w-16" />
                <div class="h-2 rounded-full bg-gray-light w-10" />
              </div>

              <div class="h-2 rounded-full bg-gray-light w-27" />
            </div>
          </div>

          <div
            v-if="cartStore.cart?.deliveryFee"
            class="flex items-center justify-between py-3 border-t border-dotted"
          >
            <span class="text-black">Delivery Fee</span>

            <span class="text-black">R{{ cartStore.cart?.deliveryFee?.toFixed(2) || '0' }}</span>
          </div>

          <div class="flex items-center justify-between py-3 border-t border-black">
            <span class="text-black">Total</span>
            <span class="text-black">R{{ cartStore.cart?.totalCost?.toFixed(2) || '0' }}</span>
          </div>

          <div class="flex flex-col items-center pb-1">
            <AppLink
              :to="{ name: 'app_cart' }"
              class="mb-4 block btn btn-solid btn-secondary w-full py-3 text-lg"
            >
              Go to Cart
            </AppLink>

            <AppButton
              class="border-none text-secondary font-medium text-lg w-fit px-5 py-0"
              @click="$emit('close')"
            >
              Continue Shopping
            </AppButton>
          </div>
        </div>
      </div>
    </div>
  </AppModal>
</template>

<script setup>
import { AppButton, AppLink, AppModal } from '@/components/app';

import { DigitalSize, PhotoType } from '@/const';
import { useCartStore } from '@/store';

const cartStore = useCartStore();

defineEmits(['close']);

</script>
